import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GET_PLAN_ADDONS, USER_PLAN_ADDONS_UPDATE } from "../../../../Urls";

const initialState = {
    getPlanAddonsData: { data: [], loader: false },
    getVoipPlanAddonsData: { data: [], loader: false },
    getTvPlanAddonsData: { data: [], loader: false },
    selectedPlanAddonsData: { data: [], loader: false },
};

export const getPlanAddons = createAsyncThunk(
    "app/planAddonsSlice/getPlanAddons",
    async (reqData) => {
        const response = await axios.post(GET_PLAN_ADDONS, reqData);
        return response;
    }
);

export const getVoipPlanAddons = createAsyncThunk(
    "app/planVoipAddonsSlice/getPlanAddons",
    async (reqData) => {
        const response = await axios.post(GET_PLAN_ADDONS, reqData);
        return response;
    }
);

export const getTvPlanAddons = createAsyncThunk(
    "app/planTvAddonsSlice/getPlanAddons",
    async (reqData) => {
        const response = await axios.post(GET_PLAN_ADDONS, reqData);
        return response;
    }
);

export const updateUserPlanAddons = createAsyncThunk(
    "app/planAddonsSlice/updatePlanAddons",
    async (reqData) => {
        const response = await axios.post(USER_PLAN_ADDONS_UPDATE, reqData);
        return response;
    }
);

export const PlanAddonsSlice = createSlice({
    name: "app/planAddonsSlice",
    initialState,
    reducers: {
        updatePlanAddonsData: (state, action) => {
            state.selectedPlanAddonsData.data.push(action?.payload)
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getPlanAddons.pending, (state) => {
                state.getPlanAddonsData.loader = true;
            })
            .addCase(getPlanAddons.fulfilled, (state, action) => {
                state.getPlanAddonsData.loader = false;
                state.getPlanAddonsData.data = action?.payload?.data?.data;
            })
            .addCase(getPlanAddons.rejected, (state) => {
                state.getPlanAddonsData.loader = false;
            })

            // tv addons
            .addCase(getTvPlanAddons.pending, (state) => {
                state.getTvPlanAddonsData.loader = true;
            })
            .addCase(getTvPlanAddons.fulfilled, (state, action) => {
                state.getTvPlanAddonsData.loader = false;
                state.getTvPlanAddonsData.data = action?.payload?.data?.data;
            })
            .addCase(getTvPlanAddons.rejected, (state) => {
                state.getTvPlanAddonsData.loader = false;
            })

            // Voip addons
            .addCase(getVoipPlanAddons.pending, (state) => {
                state.getVoipPlanAddonsData.loader = true;
            })
            .addCase(getVoipPlanAddons.fulfilled, (state, action) => {
                state.getVoipPlanAddonsData.loader = false;
                state.getVoipPlanAddonsData.data = action?.payload?.data?.data;
            })
            .addCase(getVoipPlanAddons.rejected, (state) => {
                state.getVoipPlanAddonsData.loader = false;
            })

        // // update plan addons
        // .addCase(updateUserPlanAddons.pending, (state) => {
        //     state.updatePlanAddonsData.loader = true;
        // })
        // .addCase(updateUserPlanAddons.fulfilled, (state, action) => {
        //     state.updatePlanAddonsData.loader = false;
        //     state.updatePlanAddonsData.data = action?.payload?.data?.data;
        // })
        // .addCase(updateUserPlanAddons.rejected, (state) => {
        //     state.updatePlanAddonsData.loader = false;
        // });
    }
});

export default PlanAddonsSlice.reducer;
export const {
    updatePlanAddonsData
} = PlanAddonsSlice.actions;